module.exports = __webpack_public_path__ + "img/4.1ef20a47.svg";